module.exports = __webpack_public_path__ + "statics/img/3-2.0e2e59d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/3-2.png
// module id = MS9h
// module chunks = 1